// IMPORTS
// Modules
import { useState, useEffect } from 'react';
// OHS
import { OHSAppHeader, OHSAppBody, OHSAppFooter } from '../../onehivesystems/js/OHSApp';
import OHSCRUD from '../../onehivesystems/js/OHSCRUD';
import OHSWidget from '../../onehivesystems/js/OHSWidget';
import OHSFilter from '../../onehivesystems/js/OHSFilter';
import OHSList, { OHSListDataFormatter } from '../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormSelectBuilder, OHSFormDataExtractor, OHSFormDataClearer } from '../../onehivesystems/js/OHSForm';
// Assets
import './AuditLogs.scss';
import Log from './Modules/Log';
import { logModel } from './_variables';


// COMPONENT
export default function AuditLogs (props) {
   // States and Variables
   const [logs, setLogs] = useState(null);
   const [logPopups, setLogPopups] = useState({});

   // On-Load
   useEffect(function () {
      props.onehive.setOneHiveTitle("Audit Logs"); // set page title
   }, []);

   // Functions
   const searchLogs = function () {
      OHSCRUD({
         url: '/v1/onehive/auditlogs',
         method: 'POST',
         payload: OHSFormDataExtractor('auditlogs-search'),
         success: function (data) {
            setLogs(OHSListDataFormatter(data, logModel));
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup
      });
   }

   // Component
   return (
      <div className="auditlogs">
         <OHSAppHeader onehive={props.onehive} title="Audit Logs" help="https://www.onehivesystems.com/documentation/auditlogs" />
         <OHSAppBody onehive={props.onehive}>
            <OHSWidget onehive={props.onehive} title="Search Logs" onEnter={searchLogs}>
               <div id="auditlogs-search" className='auditlogs-search'>
                  <OHSFormItem onehive={props.onehive} title="From">
                     <input type='datetime-local' className='ohsinput' data-ohsformdata="time_from" />
                  </OHSFormItem>
                  <OHSFormItem onehive={props.onehive} title="To">
                     <input type='datetime-local' className='ohsinput' data-ohsformdata="time_to" />
                  </OHSFormItem>
                  <OHSFormItem onehive={props.onehive} title="Search Field">
                     <OHSFormSelectBuilder onehive={props.onehive} content={["User", "Application", "Severity", "Message"]} simple={true} blank={true} ohsformdata="search_field" />
                  </OHSFormItem>
                  <OHSFormItem onehive={props.onehive} title="Search Term">
                     <input type='text' className='ohsinput' data-ohsformdata="search_term" />
                  </OHSFormItem>
                  <OHSFormSubmit onehive={props.onehive} custom={[
                     {
                        title: "Search",
                        action: searchLogs,
                        class: "ohsbtn-success"
                     },
                     {
                        title: "Clear",
                        action: () => {OHSFormDataClearer('auditlogs-search');},
                        class: "ohsbtn"
                     }
                  ]} keyListener={true} />
               </div>
            </OHSWidget>
            <OHSFilter onehive={props.onehive} title="Filter Logs" container="auditlogs-list" />
            <OHSWidget onehive={props.onehive} id="auditlogs-list" title="Logs">
               <OHSList onehive={props.onehive} content={logs} popups={logPopups} setPopups={setLogPopups} template={
                  <Log onehive={props.onehive} parent={{
                     logs: logs,
                     setLogs: setLogs
                  }} />
               } />
            </OHSWidget>
         </OHSAppBody>
         <OHSAppFooter onehive={props.onehive} />
      </div>
   );
}